module.exports = __webpack_public_path__ + "img/signal_red.5ecae226.png";